import { IconButton } from '@trg/tlw-ui-component';
import { useLayoutStore } from '../../../layout';
import clsx from 'clsx';

export function Favorite() {
  const isFavoriting = useLayoutStore.use.isFavoriting();

  return (
    <IconButton
      className={clsx(
        'tlw-p-0 tlw-text-2xl lg:tlw-text-xl',
        isFavoriting && 'tlw-text-txt-core'
      )}
      icon="HeartBg"
      href="/customerTracking/list?currentPage=1"
      square
    />
  );
}
